/* Quiet like the header's "New space": no fill until hovered or open, so it doesn't compete with the rows */
.trigger {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-0_5);
  min-height: var(--tuna-spacing-4);
  padding-inline: var(--tuna-spacing-1);
  border: 0;
  border-radius: var(--tuna-shape-radius-md);
  background: transparent;
  color: var(--tuna-content-secondary);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.trigger:hover,
.trigger[data-popup-open] {
  background-color: var(--tuna-palette-action-selected);
}

.trigger:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.menu {
  min-width: calc(var(--tuna-spacing-4) * 6);
}

/* Phone: icon only, with a 44px target; the accessible name still says "Sort spaces: <order>" */
@media (max-width: 599.95px) {
  .trigger {
    justify-content: center;
    min-width: calc(var(--tuna-spacing-5) + var(--tuna-spacing-0_5));
    min-height: calc(var(--tuna-spacing-5) + var(--tuna-spacing-0_5));
    padding-inline: 0;
  }

  .label {
    display: none;
  }
}
